<template>
  <v-container fluid tag="section">
    <v-data-table
      id="organizations-table"
      :headers="headers"
      :items="organizationsList"
      :items-per-page="10"
      class="elevation-2"
      height="100%"
    />

    <add-organization-button/>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'OrganizationTable',

  components: {
    AddOrganizationButton: () => import('./AddOrganizationButton')
  },

  data () {
    return {
      headers: [
        {
          text: 'Name',
          align: 'start',
          value: 'name'
        },
        { text: 'Users', value: 'users' }
      ]
    }
  },

  async created () {
    await this.setupState()
    await this.requestAllOrganizations()
  },

  computed: {
    ...mapState({
      organizations: state => state.organization.organizations
    }),

    organizationsList () {
      var ret = []
      for (var organization of this.organizations) {
        var org = {
          name: organization.name,
          users: organization.userCount
        }
        ret.push(org)
      }
      return ret
    }
  },

  methods: {
    ...mapActions(['setupState', 'requestAllOrganizations'])
  }
}
</script>

<style lang="sass" scoped>
  #organizations-table .v-data-footer
    justify-content: start
</style>
